export const getContainedSize = (img) => {
  const ratio = img.naturalWidth / img.naturalHeight || 1;
  let width = img.height * ratio;
  let height = img.height;

  if (width > img.width) {
    width = img.width;
    height = img.width / ratio;
  }

  return [width, height];
};
